import { httpClient } from '@/network/clientController'

/** Consult Secure Association
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_secureassociation
*/
export const consultSecureAssociation = payload => {
	return httpClient({
		method: 'GET',
		url: 'secure/association'
	})
}

/** Delete Secure Association Enrollment
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_secureassociation
*/
export const deleteSecureAssociation = payload => {
	return httpClient({
		method: 'DELETE',
		url: 'secure/association',
		params: payload
	})
}

/** Initiate enrollment process.
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_secureassociationenrollment
*/
export const initiateEnrollmentProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'secure/association/enrollment',
		params: payload.params,
		data: payload.data
	})
}

/** Retry Initiate enrollment process.
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_secureassociationenrollmentretry
*/
export const retryInitiateEnrollmentProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'secure/association/enrollment/retry',
		params: payload.params,
		data: payload.data
	})
}

/** Confirm enrollment process.
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_secureassociationenrollmentconfirm
*/
export const confirmEnrollmentProcess = payload => {
	return httpClient({
		method: 'POST',
		url: 'secure/association/enrollment/confirm',
		params: payload.params,
		data: payload.data
	})
}
